import { createEntityAdapter } from "@reduxjs/toolkit";
import { Hyperlink } from "./dataTypes";

export const hyperlinkAdapter = createEntityAdapter<Hyperlink>({});
